import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Bot, RefreshCw, ShieldAlert, TriangleAlert } from "lucide-react";

type AgentGatewayStateProps = {
  actionLabel?: string;
  description: string;
  kind: "empty" | "forbidden" | "missing" | "unavailable";
  onAction?: () => void;
  title: string;
};

const icons = {
  empty: Bot,
  forbidden: ShieldAlert,
  missing: TriangleAlert,
  unavailable: TriangleAlert,
};

export function AgentGatewayState({
  actionLabel = "Try again",
  description,
  kind,
  onAction,
  title,
}: AgentGatewayStateProps) {
  const Icon = icons[kind];

  return (
    <Card
      className="mx-auto w-full max-w-xl border-slate-200 shadow-none"
      role={kind === "empty" ? "status" : "alert"}
    >
      <CardHeader className="items-center text-center">
        <span className="flex size-12 items-center justify-center rounded-full bg-slate-100 text-slate-700">
          <Icon aria-hidden="true" className="size-6" />
        </span>
        <CardTitle className="mt-2 text-xl">{title}</CardTitle>
        <CardDescription className="max-w-md">{description}</CardDescription>
      </CardHeader>
      {onAction ? (
        <CardContent className="flex justify-center">
          <Button onClick={onAction} variant="outline">
            <RefreshCw aria-hidden="true" />
            {actionLabel}
          </Button>
        </CardContent>
      ) : null}
    </Card>
  );
}
